import { InjectionToken } from "@angular/core";
import { QuantityInputBareChangeResult } from "projects/shared/lib/components/shared/base/quantity-input/quantity-input-bare/change-result/quantity-input-bare-change-result.model";

export interface IQuantityValidationService {
  validateQuantity(quantity: number, minimumOrderAmount: number, maximumOrderAmount: number): QuantityInputBareChangeResult;
}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IQuantityValidationServiceToken = new InjectionToken<IQuantityValidationService>('IQuantityValidationServiceToken');
